/* vDEV */
(() => {
  
  class Theme {
  
    settings = {}
  
    tools = {
      cookie: {
        get: (name) => {
          const value = `; ${document.cookie}`;
    
          if (document.cookie.includes(`; ${name}=`)) {
            const parts = value.split(`; ${name}=`);
            
            if (parts.length === 2) {
              return parts.pop().split(';').shift();
            }
          }
          
          return '';
        },
        set: (name, value, days = 365) => {
          var expires = '';
          
          var date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          
          const cookieText = `${name}=${value}; expires=${date.toUTCString()}; domain=.${window.location.hostname}; path=/`;
          document.cookie = cookieText;
        }
      }
    }
  
    constructor() {
      const obj = this;
      window.themeObj = obj;
   
      obj.seo();
      obj.metaRobotsTag();
      obj.loadTemplates();
      obj.loadSections();
    }
    
    seo() {
      
      (function () {
        var keys = ['_pos','_sid','_ss'];
        var deleteRegex = new RegExp(keys.join('=|') + '=')
        var params = location.search.slice(1).split('&')
        if(params[0] != ''){
          var search = []
          for (var i = 0; i < params.length; i++) if (deleteRegex.test(params[i]) === false) search.push(params[i])
          window.history.replaceState({}, document.title, location.pathname + (search.length ? '?' + search.join('&') : '') + location.hash)
        }
      })();
  
      /* Remove !# from URL
      let currentUrl = window.location.href;
  
      if (currentUrl.includes('#!')) {
        let newUrl = currentUrl.replace(/#!/, '');
        history.replaceState(null, '', newUrl);
      }
      /* /Remove !# from URL */
    }

    metaRobotsTag() {
      const urlParams = new URLSearchParams(window.location.search);
      //console.log('metaRobotsTag', 'urlParams', urlParams, '_pos', urlParams.has('_pos'));
      
      const regex = /\/collections?\/.*\/products\/.*/i;
      //console.log("regex:", regex.test(window.location.href));
      //console.log("href", window.location.href);
      //console.log("search:", window.location.search, "length:", window.location.search.length);
      //if (window.location.href.includes('?q=') || urlParams.has('pr_prod_strat') ||urlParams.has('_pos') || urlParams.has('variant') || urlParams.has('currency') || urlParams.has('page') || window.location.href.substr(-2) == '#!' || regex.test(window.location.href) ) {
      if ( window.location.search.length > 0 || window.location.href.substr(-2) == '#!' || regex.test(window.location.href || window.location.pathname == '/pages/campagna-vista') ) {
        let meta = document.querySelector('meta[name="robots"]');
        // console.log('metaRobotsTag', 'meta', meta);  
        if (meta) {
          meta.content = 'noindex, nofollow';
          
        } else {
          meta = document.createElement('meta');
          meta.name = 'robots';
          meta.content = 'noindex, nofollow';
          
          document.head.appendChild(meta);
        }
      }
    };
    
    templates = [
      {
        key: 'product',
        value: () => new class {
  
          constructor() {
            const obj2 = this;
            
            obj2.init();
          }
  
          init() {          
            const obj2 = this;
            
            if (!document.body.classList.contains('template-product')) {
              return false;
            }
  
            obj2.colorPicker();
          }
  
          colorPicker() {
            const obj2 = this;
            
            class ColorPicker extends HTMLElement {
  
              settings = {
                section: this.parentNode,
                tag: this.getAttribute('data-tag'),
                productId: this.getAttribute('data-product-id')
              }
  
              constructor() {
                super();
                
                const obj3 = this;
                obj3.render();
              }
  
              render() {
                const obj3 = this;
  
                const q = `"${obj3.settings.tag}"`;
                const url = `${window.Shopify.routes.root}search?section_id=product-color-picker&q=${encodeURIComponent(q)}`;
                    
                fetch(url)
                  .then(response => {
      
                    if (!response.ok) {
                      return false;
                    }
      
                    return response.text();
                  })
                  .then(response => {
                    return new DOMParser().parseFromString(response, 'text/html');
                  })
                  .then(response => {
                    const fetchContent = response.querySelector('color-picker');
            
                    if (!fetchContent) {
                      return false;
                    }
  
                    let fetchProducts = fetchContent.querySelectorAll('.product-block');
      
                    if (!fetchProducts.length) {
                      return false;
                    }
      
                    fetchProducts.forEach((fetchProduct) => {
                      const fetchProductDetail = fetchProduct.querySelector('.product-block__detail');
                      fetchProductDetail.remove();
      
                      const fetchProductId = fetchProduct.getAttribute('data-product-id');
      
                      if (obj3.settings.productId == fetchProductId) {
                        fetchProduct.parentNode.remove();
                      }
                    });
                    
                    fetchProducts = fetchContent.querySelectorAll('.product-block');
      
                    if (fetchProducts.length) {
                      obj3.innerHTML = fetchContent.innerHTML;
                      obj3.settings.section.setAttribute('loaded', true);
                    }
                  });
              }
            }
            
            customElements.define('color-picker', ColorPicker);   
          }
        }
      }
    ]
  
    loadTemplates() {
      const obj = this;
  
      obj.templates.forEach((template) => {
        template.value();
      });
    }
    
    sections = [
      {
        key: 'footer',
        value: class {

          constructor() {
            const titles = document.querySelectorAll('.section-footer__title');

            if (!titles.length) {
              return;
            }

            titles.forEach((title) => {
              title.addEventListener('click', () => {
                title.parentNode.classList.toggle('is-expanded');
              });
            });
          }
        }
      },
      {
        key: 'product-block-colors',
        value: class {
  
          constructor() {
            const obj2 = this;
  
            obj2.productColors();
          }
  
          productColors() {
            const obj2 = this;
  
            class ProductBlockColors extends HTMLElement {
    
              settings = {
                tag: this.getAttribute('data-tag')
              }
    
              constructor() {
                super();
                
                const obj3 = this;
  
                if (obj3.classList.contains('is-rendered')) {
                  return false;
                }
  
                const query = `"${obj3.settings.tag}"`;
                const url = `${window.Shopify.routes.root}search?type=product&view=product-block-colors&q=${encodeURIComponent(query)}`;
                
                fetch(url, {
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                  }
                })
                  .then(response => {
            
                    if (!response.ok) {
                      return false;
                    }
            
                    return response.json();
                  })
                  .then((response) => {
                    obj3.classList.add('is-rendered');
  
                    if (!response.product_colors) {
                      return false;
                    }
  
                    obj3.textContent = response.product_colors;
                  });
              }
            }
            
            customElements.define('product-block-colors', ProductBlockColors);   
          }
        }
      },
      
      {
        key: 'cart',
        value: class {
  
          settings = {
            appUrl: 'https://shopify.eye-oo.com/cart-wishlist'
          }
              
          constructor() {
            const obj2 = this;
            
            obj2.customer();
          }
  
          customer() {
            const obj2 = this;
            
            class CartCustomer extends HTMLElement {
  
              constructor() {
                super();
                
                const obj3 = this;
                
                obj3.events();
                obj3.compareCartVsMetafield();
              }
  
              events() {
                const obj3 = this;
  
                document.addEventListener('on:cart:add', (event) => {
                  obj3.getCartAndUpdateMetafield();
                });
  
                document.addEventListener('on:cart:change', (event) => {
                  obj3.getCartAndUpdateMetafield();
                });
  
                document.addEventListener('dispatch:cart-drawer:refresh', (event) => {
                  obj3.getCartAndUpdateMetafield();
                });
              }
  
              compareCartVsMetafield() {
                const obj3 = this;
                
                const cartItems = JSON.parse(obj3.querySelector('script[data-source="cart"]').innerHTML);
                const metafieldItems = JSON.parse(obj3.querySelector('script[data-source="metafield"]').innerHTML);
                
                if (Object.keys(cartItems) && !metafieldItems.length) {
                  obj3.updateMetafield(cartItems);
                  
                } else if (!Object.keys(cartItems) && metafieldItems.length) {
                  obj3.updateCart(metafieldItems);
                }
              }
              
              updateMetafield(items) {
                const obj3 = this;
  
                const form = obj3.querySelector('form');
                form.querySelector('input[name="items"]').value = JSON.stringify(items);
        
                const formUrl = `${obj2.settings.appUrl}/ajax:cart/update.json?shop=${Shopify.shop}`;
                const formMethod = 'POST';
                const formBody = new FormData(form);
          
                fetch(formUrl, {
                  method: formMethod,
                  body: formBody
                })
                  .then((response) => {
                  
                    if (!response.ok) {
                      return false;
                    }
                    
                    return response.json();
                });
              }
  
              getCartAndUpdateMetafield() {
                const obj3 = this;
  
                const formUrl = `${Shopify.routes.root}cart.js`;
          
                fetch(formUrl, {
                  headers: {
                    'Content-Type': 'application/json'
                  }
                })
                  .then((response) => {
                  
                    if (!response.ok) {
                      return false;
                    }
                    
                    return response.json();
                })
                  .then((response) => {
                    const items = response.items;
                    
                    if (!items) {
                      return false;
                    }
          
                    let updates = {};
  
                    items.forEach((item) => {
                      updates[item.variant_id] = item.quantity;
                    });
                    
                    obj3.updateMetafield(updates);
                });              
              }
  
              updateCart(updates) {
                const obj3 = this;
          
                if (!updates) {
                  return false;
                }
          
                const formUrl = `${Shopify.routes.root}cart/update.js`;
                const formMethod = 'POST';
                const formBody = JSON.stringify({ updates });
          
                fetch(formUrl, {
                  method: formMethod,
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: formBody
                })
                  .then((response) => {
                  
                    if (!response.ok) {
                      return false;
                    }
                    
                    return response.json();
                })
                  .then((response) => {
                    const eventName = 'dispatch:cart-drawer:refresh';
                    const event = new CustomEvent(eventName);
                    document.dispatchEvent(event);
                });
              }
            }
  
            customElements.define('cart-customer', CartCustomer);
          }
        }
      },
  
      {
        key: 'wishlist',
        value: class {
      
          settings = {
            appUrl: 'https://shopify.eye-oo.com/cart-wishlist',
            cookieId: 'shopify--wishlist:products'
          }
          
          constructor() {
            const obj2 = this;
  
            obj2.events();
            
            obj2.customer();
            obj2.button();
            obj2.landing();
            obj2.product();
          }
      
          events() {
            const obj2 = this;
            
            document.addEventListener('theme:wishlist:activate', (event) => {
              const item = event.detail.product;
              const items = obj2.addCookieItem(item.id, item.handle);
              
              const event2Name = 'theme:wishlist:changed';
              const event2 = new CustomEvent(event2Name, {
                detail: {
                  products: items
                }
              });
              document.dispatchEvent(event2);
            });
            
            document.addEventListener('theme:wishlist:deactivate', (event) => {
              const item = event.detail.product;
              const items = obj2.removeCookieItem(item.id, item.handle);
              
              const event2Name = 'theme:wishlist:changed';
              const event2 = new CustomEvent(event2Name, {
                detail: {
                  products: items
                }
              });
              document.dispatchEvent(event2);
            });
          }
      
          /* Cookie */
          getCookieItems() {
            const obj2 = this;
            
            const itemsText = window.themeObj.tools.cookie.get(obj2.settings.cookieId);
            let items = [];
      
            if (itemsText) {
              items = JSON.parse(itemsText);
            }
  
            return items;
          }
          
          addCookieItem(id, handle) {
            const obj2 = this;
            
            const items = obj2.getCookieItems();
            
            let newItems = items;
            let newItemsFound = false;
  
            items.forEach((item) => {
              
              if (item.id == id && item.handle == handle) {
                newItemsFound = true;
              }
            });
    
            if (!newItemsFound) {
              newItems.unshift({
                id: parseInt(id),
                handle: handle
              });
            }
  
            window.themeObj.tools.cookie.set(obj2.settings.cookieId, JSON.stringify(newItems));
  
            return newItems;
          }
          
          removeCookieItem(id, handle) {
            const obj2 = this;
            
            let items = obj2.getCookieItems();
  
            items.forEach((item, itemI) => {
              
              if (item.id == id && item.handle == handle) {
                items.splice(itemI, 1);
              }
            });
      
            window.themeObj.tools.cookie.set(obj2.settings.cookieId, JSON.stringify(items));
            
            return items;
          }
          /* /Cookie */
  
          customer() {
            const obj2 = this;
            
            class WishlistCustomer extends HTMLElement {
  
              constructor() {
                super();
  
                const obj3 = this;
                obj3.events();
                obj3.compareCookieVsMetafield();
              }
  
              events() {
                const obj3 = this;
                
                document.addEventListener('theme:wishlist:changed', (event) => {
                  const products = event.detail.products;
                  obj3.updateMetafield(products);
                });
              }
  
              compareCookieVsMetafield() {
                const obj3 = this;
                
                const cookieItems = obj2.getCookieItems();
                const metafieldItems = JSON.parse(obj3.querySelector('script[data-source="metafield"]').innerHTML);
  
                if (cookieItems.length && !metafieldItems.length) {
                  obj3.updateMetafield(cookieItems);
                  
                } else if (!cookieItems.length && metafieldItems.length) {
                  obj3.updateCookies(metafieldItems);
                }
              }
              
              updateCookies(items) {
                const obj3 = this;

                if (!items) {
                  return false;
                }

                items.forEach((item) => {
                  obj2.addCookieItem(item.id, item.handle);
                });
              }
              
              updateMetafield(items) {
                const obj3 = this;
                
                obj3.querySelector('input[name="products"]').value = JSON.stringify(items);
  
                const form = obj3.querySelector('form');
                const formUrl = `${obj2.settings.appUrl}/ajax:wishlist/update.json?shop=${Shopify.shop}`;
                const formMethod = 'POST';
                const formBody = new FormData(form);
          
                fetch(formUrl, {
                  method: formMethod,
                  body: formBody
                })
                .then((response) => {
                
                  if (!response.ok) {
                    return false;
                  }
                  
                  return response.json();
                })
                .then(function (response) {
                });
              }
            }
            
            customElements.define('wishlist-customer', WishlistCustomer);
          }
          
          button() {
            const obj2 = this;
            
            class WishlistButton extends HTMLElement {
  
              settings = {
                product: {
                  id: this.getAttribute('data-product-id'),
                  handle: this.getAttribute('data-product-handle')
                }
              }
  
              constructor() {
                super();
  
                const obj3 = this;
                
                obj3.render();
              }
  
              render() {
                const obj3 = this;
  
                if (obj3.check()) {
                  obj3.activate();
                }
                  
                obj3.addEventListener('click', () => {
      
                  if (obj3.classList.contains('is-active')) {
                    obj3.deactivate();
                  
                  } else {
                    obj3.activate();
                  }
                });
                
                obj3.classList.add('is-rendered');
              }
              
              check() {
                const obj3 = this;
      
                const items = obj2.getCookieItems();
      
                for (let i = 0; i < items.length; i++) {
                  const item = items[i];
                  
                  if (item.id == obj3.settings.product.id && item.handle == obj3.settings.product.handle) {
                    return true;
                  }
                }
                
                return false;
              }
              
              activate() {
                const obj3 = this;
                
                obj3.classList.add('is-active');
                
                const eventName = 'theme:wishlist:activate';
                const event = new CustomEvent(eventName, {
                  detail: {
                    product: obj3.settings.product
                  }
                });
                document.dispatchEvent(event);
              }
              
              deactivate() {
                const obj3 = this;
                
                obj3.classList.remove('is-active');
                
                const eventName = 'theme:wishlist:deactivate';
                const event = new CustomEvent(eventName, {
                  detail: {
                    product: obj3.settings.product
                  }
                });
                document.dispatchEvent(event);
              }
            }
  
            customElements.define('wishlist-button', WishlistButton);
          }
  
          landing() {
            const obj2 = this;
            
            class WishlistLanding extends HTMLElement {
  
              constructor() {
                super();
  
                const obj3 = this;
                obj3.render();
              }
  
              render() {
                const obj3 = this;
                
                const items = obj2.getCookieItems();
      
                obj3.setAttribute('data-items', items.length);
                obj3.classList.add('is-rendered');
          
                if (!items.length) {
                  return false;
                }
  
                const itemsElement = document.querySelector('wishlist-products');
                itemsElement.innerHTML = '';
  
                items.forEach((item) => {
                  const itemElement = document.createElement('wishlist-product');
                  itemElement.classList.add('cart-item');
                  itemElement.classList.add('is-loading');
                  
                  itemElement.setAttribute('data-product-id', item.id);
                  itemElement.setAttribute('data-product-handle', item.handle);
                  
                  itemElement.innerHTML = `
                    <div class="cart-item__column cart-item__image">
                      <a href="javascript:void(0);">
                        <span class="theme-img animate--loading-bg"></span>
                      </a>
                    </div>
                    <div class="cart-item__not-image">
                      <div class="cart-item__column cart-item__description">
                        <div class="lightly-spaced-row">
                          <div class="cart-item__title"> 
                            <a href="javascript:void(0);"
                               class="text-current animate--loading-bg"></a>
                          </div>
                        </div>
                      </div>
                      <div class="cart-item__column cart-item__price"></div>
                      <div class="cart-item__column cart-item__quantity"></div>
                      <div class="cart-item__column cart-item__total"></div>
                    </div>  
                  `;
                  itemsElement.append(itemElement);
                });
              }
            }
            
            customElements.define('wishlist-landing', WishlistLanding);
          }
  
          product() {
            const obj2 = this;
            
            class WishlistProduct extends HTMLElement {
  
              settings = {
                product: {
                  id: this.getAttribute('data-product-id'),
                  handle: this.getAttribute('data-product-handle')
                }
              }
  
              constructor() {
                super();
  
                const obj3 = this;
                obj3.render();
              }
  
              render() {       
                const obj3 = this;
                
                if (!obj3.settings.product.id || !obj3.settings.product.handle) {
                  return false;
                }
      
                const formUrl = `${window.Shopify.routes.root}products/${obj3.settings.product.handle}?section_id=wishlist-product`;
          
                fetch(formUrl)
                  .then((response) => {
                  
                    if (!response.ok) {
                      return false;
                    }
                    
                    return response.text();
                  })
                  .then(response => {
                    const fetchContent = new DOMParser()
                      .parseFromString(response, 'text/html')
                      .querySelector('wishlist-product');
                    
                    if (!fetchContent) {
                      return false;
                    }
  
                    obj3.innerHTML = fetchContent.innerHTML;
      
                    const removeButton = obj3.querySelector('.cart-item__remove');
          
                    removeButton.addEventListener('click', (event) => {
                      event.preventDefault();
  
                      const event2Name = 'theme:wishlist:deactivate';
                      const event2 = new CustomEvent(event2Name, {
                        detail: {
                          product: obj3.settings.product
                        }
                      });
                      document.dispatchEvent(event2);
  
                      removeButton.removeEventListener('click', () => {});
                      obj3.remove();
                      
                      const items = document.querySelectorAll('wishlist-product');
                
                      const wrapper = document.querySelector('wishlist-landing');
                      wrapper.setAttribute('data-items', items.length);
                    });
                  });
              }
            }
          
            customElements.define('wishlist-product', WishlistProduct);
          }
        }
      },
      
      {
        key: 'product-popup',
        value: class {
  
          settings = {
            appUrl: 'https://n8n.eye-oo.com/webhook/odoo',
            cookieId: 'shopify--wishlist:products'
          }
          
          constructor() {
            const obj2 = this;
  
            obj2.popup();
            obj2.form();
          }
  
          popup() {
            const obj2 = this;
  
            const sections = document.querySelectorAll('.shopify-section--product-popup');
    
            if (!sections.length) {
              return false;
            }
  
            sections.forEach((section) => {
              const sectionPopup = section.querySelector('modal-dialog');
    
              if (!sectionPopup) {
                return false;
              }
              
              const sectionPopupId = sectionPopup.getAttribute('id');
    
              if (window.location.hash == `#${sectionPopupId}`) {
                const sectionPopupButton = document.getElementById(sectionPopupId);
                
                if (sectionPopupButton) {
                  sectionPopupButton.open();
                }
              }
            });
          }
  
          form() {
            const obj2 = this;
            
            class N8nForm extends HTMLElement {
  
              settings = {
                url: this.getAttribute('data-form-url'),
                type: this.getAttribute('data-form-type'),
                form: this.querySelector('form'),
                button: this.querySelector('button.btn[data-n8n-form--action="submit"]')
              }
  
              constructor() {
                super();
                
                const obj3 = this;
                
                obj3.events();
                
                obj3.requiredFields();
                obj3.variantsField();
                obj3.storesField();
              }
  
              events() {
                const obj3 = this;
  
                obj3.settings.form.addEventListener('submit', (event) => {
                  event.preventDefault();
                  event.stopPropagation();
  
                  return false;
                });
  
                obj3.settings.button.addEventListener('click', () => {
                  obj3.form__submit();
                });
              }
  
              field__validate(formField) {
                const obj3 = this;
  
                const formFieldInput = formField.querySelector('input, textarea');
                const formFieldInputValue = formFieldInput.value.trim();
                
                if (formFieldInputValue.length) {
                  formField.classList.remove('is-invalid');
  
                } else {
                  formField.classList.add('is-invalid');
                }
              }

              requiredFields() {
                const obj3 = this;
  
                let formFields = obj3.settings.form.querySelectorAll('.column.is-required');
  
                formFields.forEach((formField) => {
                  const formFieldValue = formField.value;
  
                  formField.addEventListener('change', () => {
                    obj3.field__validate(formField);
                  });
                  
                  formField.addEventListener('keyup', () => {
                    obj3.field__validate(formField);
                  });
                });
  
                formFields = obj3.settings.form.querySelectorAll('.column.is-required');
  
                if (!formFields.length) {
                  const formButton = obj3.settings.form.querySelector('button.btn[data-action="submit"]');
  
                  if (formButton) {
                    formButton.removeAttribute('disabled');
                  }
                }
              }
  
              /* Field: Variants */
              variantsField() {
                const obj3 = this;
  
                const productForm__wrapper = document.querySelector('product-form');
                const productForm = productForm__wrapper.querySelector('form');
  
                productForm.addEventListener('change', () => {
                  const productVariant = productForm__wrapper.querySelector('.option-selector[data-option="Shopify_option1"] input[type="radio"]:checked');
    
                  if (!productVariant) {
                    return false;
                  }
    
                  const productVariant__sku = obj3.querySelector('[data-n8n-form--name="sku"]');
    
                  if (productVariant__sku) {
                    productVariant__sku.value = productVariant.getAttribute('data-variant-sku');
                  }
    
                  const productVariant__quantity = obj3.querySelector('[data-n8n-form--name="product_variant_qty"]');
    
                  if (productVariant__quantity) {
                    productVariant__quantity.value = productVariant.getAttribute('data-variant-quantity');
                  }

                  const modalOpener = document.querySelector(`modal-opener[data-modal="contact-modal__${obj3.settings.type}"] button`);
                  
                  if (modalOpener) {
                    
                    if (productVariant__quantity.value > 0) {
                      modalOpener.removeAttribute('disabled');
                      
                    } else {
                      modalOpener.setAttribute('disabled', 'disabled');
                    }
                  }
    
                  const productVariant__id = obj3.querySelector('[data-n8n-form--name="product_variant_id"]');
    
                  if (productVariant__id) {
                    productVariant__id.value = productForm__wrapper.querySelector('[name="id"]').value;
                  }
    
                  const productVariant__value = obj3.querySelector('[data-n8n-form--name="shopify_option1"]');
    
                  if (productVariant__value) {
                    // productVariant__value.value = productVariant.value;
                    productVariant__value.value = productVariant.getAttribute('value');
                  }
                  
                  const productVariant__imageUrl = obj3.querySelector('[data-n8n-form--name="image_url"]');
    
                  if (productVariant__imageUrl) {
                    productVariant__imageUrl.value = productVariant.getAttribute('data-variant-image-url');
                  }
                });
              }
              /* /Field: Variants */
  
              /* Field: Stores */
              storesField() {
                const obj3 = this;
  
                document.addEventListener('theme:modal:opened', (event) => {
                  const modal = event.detail.modal;
                  const n8nForm = modal.querySelector('n8n-form');
  
                  if (!n8nForm) {
                    return false;
                  }
                  
                  n8nForm.storesField__render();
                });
              }
              
              async storesField__render() {
                const obj3 = this;
            
                let items;
  
                const cookieItems = obj3.storesField__getCookieItems();
  
                if (cookieItems.length) {
                  items = cookieItems;
                
                } else {
                  items = await obj3.storesField__getRemoteItems();
  
                  if (items && items.length) {
                    await obj3.storesField__setCookieItems(items);
                  }
                }
                
                await obj3.storesField__renderByItems(items);
              }
  
              async storesField__renderByItems(items) {
                const obj3 = this;
                
                if (!items || !items.length) {
                  return false;
                }
  
                let formField__nativeSelect = obj3.settings.form.querySelector('select[data-n8n-form--name="store"]');
      
                if (!formField__nativeSelect) {
                  return false;
                }
  
                if (formField__nativeSelect.classList.contains('is-rendered')) {
                  return false;
                }
  
                formField__nativeSelect.classList.add('is-rendered');
  
                const formField__wrapper = formField__nativeSelect.closest('.column');
                const formField = formField__nativeSelect.closest('.option-selector');
                
                /* Availability */
                const productTags = JSON.parse(document.getElementById('product-json-tags').innerText);
  
                const formField__availability__match = formField__nativeSelect.getAttribute('data-availability-match');
                const formField__availability__notMatch = formField__nativeSelect.getAttribute('data-availability--not-match');
  
                const formField__availableInStore = obj3.settings.form.querySelector('input[name="contact[available_in_store]"]');
                /* /Availability */
                
                const formField__customSelect = formField.querySelector('.custom-select__wrapper');
                
                const itemsElement = formField.querySelector('.custom-select__listbox');
  
                let itemI = 0;
  
                items.forEach((item) => {
                  let itemElement;
  
                  /* Custom select item */
                  itemElement = document.createElement('li');
                  itemElement.classList.add('custom-select__option');
                  itemElement.classList.add('flex');
                  itemElement.classList.add('items-center');
                  itemElement.classList.add('js-option');
  
                  itemElement.setAttribute('data-value', item.code);
  
                  let item__availableInStore = false;
                  let item__availability = formField__availability__notMatch;
  
                  if (productTags.includes(item.code)) {
                    item__availableInStore = true;
                    item__availability = formField__availability__match;
                  }
                  
                  itemElement.id = `${formField__customSelect.id}-opt-${itemI}`;
  
                  const itemText = `${item.shop} - ${item__availability}`;
                  const itemHTML = `<span>${item.shop}</span><span>${item__availability}</span>`;

                  if (item__availableInStore) {
                    itemElement.classList.add('is-available');
                  }
                  
                  if (!itemI) {
                    itemElement.setAttribute('aria-selected', true);
  
                    const button = formField.querySelector('.custom-select__btn .text-start');
                    // button.innerText = itemText;
                    button.innerHTML = itemHTML;
                    
                    formField__availableInStore.value = item__availableInStore;
                  }
                  
                  if (item__availableInStore) {
                    /* Green */
                    // itemElement.style.color = '#00822c';
                    
                  } else {
                    /* Gray */
                    // itemElement.style.color = '#969696';
                  }
                  
                  itemElement.innerHTML = `<div class="pointer-events-none custom-select__option-label">${itemHTML}</div>`;
                  itemsElement.append(itemElement);
                  /* /Custom select item */
  
                  /* Native select item */
                  itemElement = document.createElement('option');
                  itemElement.setAttribute('value', item.code);
                  itemElement.setAttribute('data--available-in-store', item__availableInStore);
                  
                  if (!itemI) {
                    itemElement.setAttribute('selected', 'selected');
                  }
  
                  itemElement.innerHTML = itemText;
                  formField__nativeSelect.append(itemElement);
                  /* Native select item */
  
                  itemI++;
                });
  
                if (!itemI) {
                  return false;
                }
  
                formField.innerHTML = `
                  <custom-select id="${formField__customSelect.id}">
                    ${formField__customSelect.innerHTML}
                  </custom-select>
                  ${formField.querySelector('.label.js-hidden').outerHTML}
                  ${formField.querySelector('.select.js-hidden').outerHTML}
                `;
  
                formField__wrapper.classList.remove('hidden');
                
                formField__nativeSelect = formField.querySelector('select');
  
                formField__nativeSelect.addEventListener('change', () => {
                  const formField__nativeSelect__option = formField__nativeSelect.options[formField__nativeSelect.selectedIndex];
                  formField__availableInStore.value = formField__nativeSelect__option.getAttribute('data--available-in-store');
                });
              }
              
              storesField__getCookieItems() {
                const obj3 = this;
                
                const cookieId = 'shopify--n8n:stores';
                
                const itemsText = window.themeObj.tools.cookie.get(cookieId);
                let items = [];
          
                if (itemsText) {
                  items = JSON.parse(itemsText);
                }
                
                return items;
              }
  
              async storesField__setCookieItems(items) {
                const obj3 = this;
                
                const cookieId = 'shopify--n8n:stores';
                window.themeObj.tools.cookie.set(cookieId, JSON.stringify(items), 1);
              }
  
              async storesField__getRemoteItems() {
                const obj3 = this;
                
                const formUrl = 'https://n8n.eye-oo.com/webhook/odoo/stores/try/get';
  
                return await fetch(formUrl)
                  .then((response) => {
  
                    if (!response.ok) {
                      return false;
                    }
                    
                    return response.json();
                  })
                    .then((response) => {
                      return response;
                    });
              }
              /* /Field: Stores */
              
              /* Form */
              form__validate() {
                const obj3 = this;
                
                const form = obj3.querySelector('form');
                const formFields = form.querySelectorAll('.column.is-required');
  
                if (!formFields.length) {
                  return true;
                }
  
                formFields.forEach((formField) => {
                  obj3.field__validate(formField);
                });
                
                const formInvalidFields = form.querySelectorAll('.column.is-required.is-invalid');
                return (formInvalidFields.length) ? false : true;
              }
  
              async form__submit() {
                const obj3 = this;
                
                let formValid = true;
  
                obj3.settings.button.setAttribute('disabled', 'disabled');
  
                if (!obj3.form__validate()) {
                  formValid = false;
                }
  
                if (formValid) {
                  await obj3.n8n__submit();
                  
                } else {
                  obj3.settings.button.removeAttribute('disabled');
                }
              }
  
              async n8n__submit() {
                const obj3 = this;
                
                const formAlerts = obj3.settings.form.querySelector('.n8n-form__alerts');
                
                obj3.settings.button.setAttribute('disabled', 'disabled');
                
                const formFields = obj3.settings.form.querySelectorAll('[data-n8n-form--name]');
    
                if (!formFields.length) {
                  return false;
                }
                
                const formBody = new FormData();
    
                formFields.forEach((formField) => {
                  formField.setAttribute('value', formField.value);
    
                  const formFieldNewName = formField.getAttribute('data-n8n-form--name');
                  formBody.set(formFieldNewName, formField.value)
                });
    
                const formMethod = 'post';
    
                fetch(obj3.settings.url, {
                  method: formMethod,
                  body: formBody
                })
                  .then((response) => {
                  
                    if (!response.ok) {
                      return false;
                    }
    
                    return response.json();
                  })
                  .then((response) => {
                
                    if (!Array.isArray(response)) {
                      obj3.settings.button.removeAttribute('disabled');
        
                      return false;
                    }
    
                    return response;
                  })
                  .then((response) => {
                    obj3.n8n__submitted(response);
                  });
              }
              
              async n8n__submitted(items) {
                const obj3 = this;
    
                if (!items) {
                  obj3.settings.button.removeAttribute('disabled');
                  
                  return false;
                }
    
                items.forEach((item) => {
                  /* Alerts */
                  const formAlerts = obj3.settings.form.querySelector('.n8n-form__alerts');
                  formAlerts.innerHTML = '';
                  
                  if (item.message) {
                    const itemElement = document.createElement('div');
                    itemElement.classList.add('alert');
                    itemElement.setAttribute('role', 'heading');
                    itemElement.innerHTML = item.message;
                    
                    if (item.status == 'OK') {
                      itemElement.classList.add('successes');
                      itemElement.classList.add('success');
                      
                    } else {
                      itemElement.classList.add('errors');
                    }
                    
                    itemElement.innerHTML = item.message;
                    
                    formAlerts.append(itemElement);
                    formAlerts.classList.remove('hidden');
    
                  } else {
                    formAlerts.classList.add('hidden');
                  }
                  /* /Alerts */
                  
                  /* Products */
                  const formItems = obj3.querySelector('.n8n-form__products');
                  formItems.querySelector('.cart-item-list').innerHTML = '';
    
                  if (item.status == 'KO' && item['products']) {
                    
                    item['products'].forEach((product) => {
                      const itemElement = document.createElement('div');
                      itemElement.classList.add('cart-item');
                      itemElement.innerHTML = `
                        <div class="cart-item__column cart-item__image">
                          <img
                            class="theme-img"
                            src="${product.x_studio_image_url}"
                            alt="${product.name}"
                          >
                        </div>
                        <div class="cart-item__not-image">
                          <div class="cart-item__column cart-item__description">
                            <div class="cart-item__title">
                              <a
                                class="text-current"
                                href="${product.x_studio_url}"
                              >
                                ${product.name}
                              </a>
                            </div>
                          </div>
                        </div>
                      `;
                      formItems.querySelector('.cart-item-list').append(itemElement);
                    });
                    
                    formItems.classList.remove('hidden');
                  
                  } else {
                    formItems.classList.add('hidden');
                  }
                  /* /Products */
    
                  /* Fields */
                  const formFields__wrapper = obj3.querySelector('.n8n-form__fields');
    
                  if (item.status == 'OK') {
                    formFields__wrapper.classList.add('hidden');
      
                  } else {
                    formFields__wrapper.classList.remove('hidden');
                  }
                  /* /Fields */
                  
                  /* Button */
                  if (item.status == 'KO') {
                    obj3.settings.button.removeAttribute('disabled');
                  }
                  /* /Button */
                });
              }
              /* /Form */
            }
  
            customElements.define('n8n-form', N8nForm);
          }
        }
      }
    ]
  
    loadSections() {
      const obj = this;
  
      obj.sections.forEach((section) => {
        
        if (typeof section.value === 'function') {
          new section.value();
          
        } else {
          section.value;
        }
      });
    }
  };
  
  document.addEventListener('DOMContentLoaded', () => {
    new Theme;
  });
})();
/* /vDEV */